// eslint-disable-next-line default-param-last
export const initiateNormalizationWorker = (callbackParams = [], callback) => {
  // workerUrl related to folder workers
  const worker = new Worker(new URL('./normalizationWorker.js', import.meta.url));

  worker.postMessage({params: callbackParams});
  worker.onerror = (err) => err;
  worker.onmessage = (e) => {
    callback(e.data);
    worker.terminate();
  };
};

export const initiateGlobalWorker = (callback) => {
  const workerFunc = () => {
    onmessage = () => {
      postMessage('done');
    };
  };
  const workerFile = URL.createObjectURL(new Blob([`(${workerFunc.toString()})()`], {type: 'text/javascript'}));
  const worker = new Worker(workerFile);

  worker.postMessage('start');
  worker.onerror = (err) => err;
  worker.onmessage = (e) => {
    callback(e.data);
    worker.terminate();
  };
};
